(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-cart-confidence"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-atelier-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-atelier-cart-message]');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }
    if (message) message.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Could not add item');
      if (message) message.textContent = 'Added.';
      const trigger = document.querySelector('[data-atelier-cart-open]');
      if (trigger) {
        trigger.click();
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      if (message) message.textContent = 'Check options.';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-collection-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-atelier-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-atelier-cart-message]');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }
    if (message) message.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Could not add item');
      if (message) message.textContent = 'Added.';
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
      } else if (document.querySelector('[data-atelier-cart-open]')) {
        document.querySelector('[data-atelier-cart-open]').click();
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      if (message) message.textContent = 'Check options.';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-header"] && !Shopify.designMode) return;
  try {
    
  const atelierCart = document.querySelector('[data-atelier-cart]');
  const atelierCartBody = document.querySelector('[data-atelier-cart-body]');
  const atelierCartCount = document.querySelector('[data-atelier-cart-count]');

  function escapeAtelierHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatAtelierMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  }

  async function renderAtelierCart() {
    if (!atelierCartBody) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    if (atelierCartCount) {
      atelierCartCount.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    }
    if (!cart.items.length) {
      atelierCartBody.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }
    atelierCartBody.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${item.image}" alt="">` : '<div></div>';
      return `<div class="atelier-cart__item">${image}<p><strong>${escapeAtelierHtml(item.product_title)}</strong><span>Qty ${item.quantity}</span><span>${formatAtelierMoney(item.final_line_price)}</span></p></div>`;
    }).join('') + `<p class="atelier-cart__subtotal">Subtotal ${formatAtelierMoney(cart.total_price)}</p>`;
  }

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-atelier-cart-open]')) {
      if (atelierCart) atelierCart.hidden = false;
      await renderAtelierCart();
    }
    if (event.target.closest('[data-atelier-cart-close]')) {
      if (atelierCart) atelierCart.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-atelier-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-atelier-cart-message]');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }
    if (message) message.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Could not add item');
      if (message) message.textContent = 'Added to cart.';
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
      } else if (document.querySelector('[data-atelier-cart-open]')) {
        document.querySelector('[data-atelier-cart-open]').click();
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      if (message) message.textContent = 'Please check the options and try again.';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
